import Heading from '../Heading';
import PreHeading from '../PreHeading';
import BlokLink from '../StoryblokLink/BlokLink';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'october',
  'November',
  'December',
];

function formattedDate(date) {
  const hours = date.getHours();
  return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${
    // eslint-disable-next-line no-nested-ternary
    hours > 12 ? hours % 12 : hours === 0 ? 12 : hours
  }${hours < 12 ? 'AM' : 'PM'}`;
}

function formattedDateNoMonth(date) {
  const hours = date.getHours();
  return `${
    // eslint-disable-next-line no-nested-ternary
    hours > 12 ? hours % 12 : hours === 0 ? 12 : hours
  }${hours < 12 ? 'AM' : 'PM'}`;
}

function formatDate(start, end) {
  const startDate = new Date(Date.parse(`${start} GMT-6`));
  const endDate = new Date(Date.parse(`${end} GMT-6`));

  if (startDate.getDate() === endDate.getDate()) {
    return (
      <>
        {formattedDate(startDate)}&mdash;{formattedDateNoMonth(endDate)}
      </>
    );
  }

  return (
    <>
      {formattedDate(startDate)}&mdash;{formattedDate(endDate)}
    </>
  );
}

export default function Event({
  hero_heading,
  start_date,
  end_date,
  preview,
  hero_feature_image,
  full_slug,
  // _editable,
}) {
  return (
    <div className="relative h-[492px] w-[672px] bg-theme-lightgrey">
      <div
        className="absolute right-0 h-full w-3/5 bg-cover bg-no-repeat "
        style={{
          backgroundImage: `url(${hero_feature_image.filename}/m/1024x0)`,
          backgroundSize: 'cover',
        }}
      ></div>
      <div className="relative mt-[100px] flex h-[calc(100%-100px)] w-[400px] items-center bg-theme-lightgrey p-[32px]">
        <div>
          <PreHeading
            size=""
            element="h3"
            color="text-theme-darkgrey"
            className="mb-1 grid grid-cols-[auto_1fr] gap-2 align-middle text-[0.8rem] font-extralight tracking-widest text-theme-darkgrey"
          >
            {formatDate(start_date, end_date)}
          </PreHeading>
          <Heading size="4xs" className="mb-2">
            {hero_heading}
          </Heading>
          <p className="mb-3 text-sm">{preview}</p>
          <BlokLink
            className="text-sm text-theme-primary"
            full_slug={full_slug}
          >
            Get Details
          </BlokLink>
        </div>
      </div>
    </div>
  );
}
